export default {
  app: {
    weddings: {
      weddings: 'Svatby',
      pageTitle: 'Svatby - Elixír Tours',
    },
  },
};
